import { IMap } from '@nimbus-library/features/shared/models/interfaces';
import { TranslationKeys } from '@nimbus-library/features/localization/models/enums/translation-keys.enum';
import { TeamAvailability } from './i-team-availability.model';

export const presenceMap: IMap<TranslationKeys> = {
  Away: TranslationKeys.PresenceAway,
  Busy: TranslationKeys.PresenceBusy,
  BusyIdle: TranslationKeys.PresenceBusyIdle,
  Available: TranslationKeys.PresenceAvailable,
  AvailableIdle: TranslationKeys.PresenceAvailableIdle,
  InACall: TranslationKeys.PresenceBic,
  DoNotDisturb: TranslationKeys.PresenceDnd,
  OffWork: TranslationKeys.PresenceOffWork,
  InAMeeting: TranslationKeys.PresenceInAMeeting,
  InAConferenceCall: TranslationKeys.PresenceInAMeeting,
  OutOfOffice: TranslationKeys.PresenceOof,
  BeRightBack: TranslationKeys.PresenceBrb,
  UrgentInterruptionsOnly: TranslationKeys.PresenceUrgentInteruptionsOnly,
  PresenceUnknown: TranslationKeys.PresenceUnknown,
  Offline: TranslationKeys.PresenceOffline,
  [TeamAvailability.DirectAvailable]: TranslationKeys.PresenceDirectAvailable,
  [TeamAvailability.InTimeAvailable]: TranslationKeys.PresenceInTimeAvailable,
  [TeamAvailability.NoOneAvailable]: TranslationKeys.PresenceNoOneAvailable,
};
